<template>
    <div>
        <b-breadcrumb :items="items" />
        <div class="container-fluid" style="background-color: white">
            <h2 class="text-center p-3">สร้างบันทึกส่งของ</h2>
            <div class="row">
                <div class="col-sm-12">
                    <!-- Customer select -->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">เลขที่ใบแจ้งหนี้</label>
                        <div class="col-sm-5">
                            <template v-if="id">
                                <input type="text" class="form-control" disabled
                                       v-model="form.invoice_number"/>
                            </template>
                            <template v-else>
                                <multiselect
                                        @input="getSpecialCustomer"
                                        v-model="form.invoice"
                                        :options="optionInvoice"
                                        :show-labels="false"
                                        track-by="id"
                                        :customLabel="invoiceLabel"
                                        placeholder="เลือกเลขที่ใบแจ้งหนี้">
                                </multiselect>
                            </template>
                        </div>
                    </div>
                    <div class="form-group row ">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">การชำระเงิน</label>
                        <div class="col-sm-8" id="payment_type">
                            <label class="col-form-label">
                                <input  v-model="form.payment_type_id"
                                        type="checkbox"
                                        @change="clearCheckbox(form.payment_type_id)"
                                        value="1"/>
                                &nbsp;ไม่มีเก็บ
                            </label>
                            <label class="col-form-label" style="margin-left: 15px">
                                <input  v-model="form.payment_type_id"
                                        type="checkbox"
                                        value="2"/>
                                &nbsp;มีเก็บเก่า
                            </label>
                            <label class="col-form-label" style="margin-left: 15px">
                                <input  v-model="form.payment_type_id"
                                        :disabled="payment_type_status == 1"
                                        type="checkbox"
                                        value="3"/>
                                &nbsp;มีเก็บใหม่
                            </label>
                        </div>
                    </div>
                    <div class="form-group row ">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">ช่องทางการชำระเงิน</label>
                        <div class="col-sm-8">
                            <label class="col-form-label">
                                <input  v-model="form.transaction_id"
                                        type="checkbox"
                                        name="transaction_type"
                                        value="3"
                                        :disabled="form.payment_type_id == 1"
                                        required/>
                                &nbsp;เงินสด
                            </label>
                            <label class="col-form-label" style="margin-left: 15px">
                                <input  v-model="form.transaction_id"
                                        type="checkbox"
                                        name="transaction_type"
                                        value="2"/>
                                &nbsp;เงินโอน
                            </label>
                            <label class="col-form-label" style="margin-left: 15px">
                                <input  v-model="form.transaction_id"
                                        type="checkbox"
                                        name="transaction_type"
                                        :disabled="form.payment_type_id == 1"
                                        value="1"/>
                                &nbsp;เช็ค
                            </label>
                            <label class="w-25" style="margin-left: 15px" v-if="form.transaction_id.includes('1')">
                                <input  v-model="form.cheque_amount"
                                        type="number"
                                        class="w-25"
                                        value="1"/>
                                ใบ
                            </label>
                        </div>
                    </div>
                    <div class="form-group row" >
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            ยอดเงินที่รับ
                        </label>
                        <div class="col-sm-8 form-inline form-group">
                            <input  v-model="form.amount"
                                    class="form-control col-sm-6"
                                    type="number"/>
                            <span class="col-sm-2">&nbsp;บาท</span>
                        </div>
                    </div>
                    <div class="form-group row" >
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            หมายเหตุ
                        </label>
                        <div class="col-sm-8 form-inline form-group">
                            <textarea v-model="form.remark" class="form-control col-sm-6"></textarea>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            เลือกรูปภาพการส่งของ
                            <br/>
<!--                            **จำนวน 1 ภาพ-->
                        </label>
                        <div class="col-sm-5 col-form-label text-capitalize ">
                            <image-uploader @input="imageFileUpload"
                                            accept="image/*"
                                            :maxWidth="1024"
                                            :maxHeight="1024"
                                            :quality="0.9"
                                            :preview="false">
                            </image-uploader>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            เลือกรูปภาพการส่งของ
                            <br/>
<!--                            **จำนวน 1 ภาพ-->
                        </label>
                        <div class="col-sm-5 col-form-label text-capitalize ">
                            <image-uploader @input="imageFileUpload"
                                            accept="image/*"
                                            :maxWidth="1024"
                                            :maxHeight="1024"
                                            :quality="0.9"
                                            :preview="false">
                            </image-uploader>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            เลือกรูปภาพการส่งของ
                            <br/>
<!--                            **จำนวน 1 ภาพ-->
                        </label>
                        <div class="col-sm-5 col-form-label text-capitalize ">
                            <image-uploader @input="imageFileUpload"
                                            accept="image/*"
                                            :maxWidth="1024"
                                            :maxHeight="1024"
                                            :quality="0.9"
                                            :preview="false">
                            </image-uploader>
                        </div>
                    </div>
                    <div v-if="form.id && form.image_file_temp && form.image_file_temp.split(',').length > 0" class="row">
                        <div class="col-sm-4"></div>
                        <div class="col-sm-8">
                            <template v-for="(x,i) in form.image_file_temp.split(',')" v-if="i != form.image_file_temp.split(',').length-1">
                                <img class="mr-3" v-img :src="domain.slice(0, -4)+'/file/'+x" style="width: 100px;height: auto">
                            </template>
                        </div>
                    </div>

                    <div class="row" v-if="preview_image.length > 0">
                        <div class="col-sm-4"></div>
                        <div class="col-sm-8">
                            <template v-for="x in preview_image">
                                <img class="mr-3" v-img :src="x" style="width: 100px;height: auto">
                            </template>
                        </div>
                    </div>
                    <br>
                </div>
                <br/>
            </div>
            <div class="row mb-5">
                <div class="col-12 text-center">
                    <span>ประวัติการกรอกข้อมูล</span>
                    <table class="border-collapse" style="width: 100%;background-color: lightgray">
                        <tr>
                            <th>การชำระเงิน</th>
                            <th>ช่องทางการชำระ</th>
                            <th>ยอดเงิน</th>
                            <th>หมายเหตุ</th>
                            <th>ผู้บันทึก</th>
                            <th>วัน/เวลา</th>
                        </tr>
                        <tr v-for="x in form.exportation_old">
                            <td>
                                <template v-if="x.payment">
                                    {{x.payment}}
                                </template>
                                <template v-else>-</template>
                            </td>
                            <td>
                                <template v-if="x.transaction">
                                    {{x.transaction}}
                                </template>
                                <template v-else>-</template>
                            </td>
                            <td>
                                <template v-if="x.amount">
                                    {{x.amount}}
                                </template>
                                <template v-else>-</template>
                            </td>
                            <td>
                                <template v-if="x.remark">
                                    {{x.remark}}
                                </template>
                                <template v-else>-</template>
                            </td>
                            <td>
                                <template v-if="x.user">
                                    {{x.user.name}}
                                </template>
                                <template v-else>-</template>
                            </td>
                            <td>
                                {{x.updated_at | moment('D/M/Y H:m')}}
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <b-row>
                <div class="col text-center">
                    <button @click="saveExportation"
                            v-if="canViewSuperAdmin || canViewDriver || user.username == '20516'"
                            type="button"
                            class="btn btn-success">
                        <icon name="save" style="width: 25px"></icon> บันทึก</button>
                    &nbsp&nbsp
                    <button type="button"
                            class="btn btn-outline-secondary"
                            @click="goToSaveExportationList">
                        <icon name="times" style="width: 25px"></icon> ยกเลิก
                    </button>
                </div>
            </b-row>
            <br/>
        </div>
        <b-modal hide-header hide-footer ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
        <b-modal hide-header hide-footer ref="warning">
            <div class="row">
                <div class="col-12">
                    <span>กรณีลูกค้าจ่ายเงินโอน ให้เลือกไม่มีเก็บ และเลือกเงินโอน <br>กรณีลูกค้าจ่ายเช็ค/เงินสด ให้เลือกได้เฉพาะ เก็บเก่า หรือเก็บใหม่เท่านั้น</span><br>
                    <span style="color: red">หากท่านบันทึกส่งของไม่ถูกต้อง จะถูกปรับ 100 บาท ต่อการบันทึก 1 ครั้ง</span>
                </div>
                <div class="col-6 text-center" style="margin-top: 40px">
                    <button @click="saveExportationConfirm"
                            type="button"
                            class="btn btn-success">
                        <icon name="save" style="width: 25px"></icon>
                        {{ confirm_button }}</button>
                </div>
                <div :hidden="confirm_button == 'บันทึก' ? false : true" class="col-6 text-center" style="margin-top: 40px">
                    <button type="button"
                            class="btn btn-outline-secondary"
                            @click="$refs.warning.hide()">
                        <icon name="times" style="width: 25px"></icon> ยกเลิก
                    </button>
                </div>
            </div>
        </b-modal>
        <!--<pre class="alert-danger">{{optionInvoice}}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import Multiselect from "vue-multiselect";
    import moment from "moment";
    import {canViewSuperAdmin,canViewDriver} from "../../../util/Permissions";
    import {domain} from "@/util/Constants";
    import ImageUploader from "vue-image-upload-resize";
    import Loading from "@/components/Utility/Loading";
    export default {
        components: {
            Multiselect,
            ImageUploader,
            Loading
        },
        name: "save-exportation-form",
        props: {
            id: { default: null }
        },
        data() {
            return {
                items: [
                    {
                        text: "รายการบันทึกส่งของ",
                        to: {name: "save-exportation"}
                    },
                    {
                        text: "เพิ่มเติม",
                        active: true
                    }
                ],
                payment_type_status : 0,
                optionInvoice : [],
                domain : domain,
                preview_image : [],
                msg : '',
                status_loading : 3,
                counting : 0,
                confirm_button : ''
            };
        },
        created() {
            this.$store.dispatch("SaveExportation/getInvoiceByDriver",this.user.id).then(data=>{
                this.optionInvoice = data;
            });
            if(this.id){
                // this.$store.dispatch("SaveExportation/showSaveExportation",this.id);
            }
            else{
                this.$store.dispatch("SaveExportation/clearFormData");
                this.create_log_driver();
            }
        },
        watch: {
            payment_type_id() {
                if (this.counting >= 1) {
                    this.confirm_button = 'ยืนยัน'
                    this.$refs.warning.show();
                }
                this.counting++;
            },
        },

        computed: {
            canViewSuperAdmin,
            canViewDriver,
            ...mapState({
                form : state=>{
                    return state.SaveExportation.form;
                },
                user:state=>{
                    return state.Auth.user;
                },
            }),
            payment_type_id() {
                return this.form.payment_type_id;
            }
        },
        methods: {
            showLoadingModal(){
                this.$refs.loading.show();
            },
            hideLoadingModal(){
                this.$refs.loading.hide();
            },
            invoiceLabel (option) {
                if(option.customer_other){
                    return `${option.invoice_id} - ${option.customer.store_name}/${option.customer_other.store_name}`;
                }else{
                    return `${option.invoice_id} - ${option.customer ? option.customer.store_name : ''}`
                }
            },
            create_log_driver () {
                let data = {
                    user : this.user,
                    status : 'open form',
                    time : moment().format("DD-MM-YYYY HH:mm:ss")
                }
                this.$store.dispatch('SaveExportation/SaveLog',data);
            },
            imageFileUpload (file) {
                this.form.image_file.push(file)
                this.preview_image.push(file);
            },
            saveExportation(){
                this.form.payment_type_id.includes("1");
                if(!this.form.invoice_number && !this.form.invoice){
                    alert("กรุณาเลือกเลขที่ใบแจ้งหนี้");
                }
                else if(!(this.form.payment_type_id.length > 0)){
                    alert("กรุณาเลือกการชำระเงิน");
                }
                else if((this.form.payment_type_id.includes("2") || this.form.payment_type_id.includes("3"))
                    && !(this.form.transaction_id.length > 0)){
                        alert("กรุณาเลือกช่องทางการชำระเงิน");
                }
                else if((this.form.payment_type_id.includes("2") || this.form.payment_type_id.includes("3"))
                    && !this.form.amount){
                // || this.form.transaction_id.includes("2")
                        alert("กรุณาใส่ยอดเงิน");
                }
                else if((this.form.payment_type_id.includes("2") || this.form.payment_type_id.includes("3"))
                    && this.form.amount < 0){
                    alert("กรุณาใส่ยอดเงินให้ถูกต้อง");
                }
                else{
                    this.confirm_button = 'บันทึก';
                    this.$refs.warning.show();
                }
            },
            saveExportationConfirm(){
                if (this.confirm_button == 'บันทึก'){
                    this.msg = 'กำลังดาวโหลดข้อมูล กรุณารอสักครู่';
                    this.status_loading = 1;
                    this.showLoadingModal();
                    this.form.payment_type_id = this.form.payment_type_id.toString();
                    this.form.transaction_id = this.form.transaction_id.toString();

                    let data = {
                        invoice_id: "",
                        payment_type_id: this.form.payment_type_id,
                        transaction_id: this.form.transaction_id,
                        amount: this.form.amount,
                        remark : this.form.remark,
                        old_invoice_id : "",
                        cheque_amount : this.form.cheque_amount,
                    };
                    if(this.form.invoice){
                        data.invoice_id = this.form.invoice.id;
                    }
                    if(this.form.payment_type_id.includes("2")){
                        if(this.form.old_invoice){
                            data.old_invoice_id = this.form.old_invoice.id;
                        }
                    }

                    let formData = new FormData();
                    formData.append('invoice_id',data.invoice_id);
                    formData.append('payment_type_id',data.payment_type_id);
                    formData.append('transaction_id',data.transaction_id);
                    formData.append('old_invoice_id',data.old_invoice_id);
                    formData.append('amount',data.amount);
                    formData.append('remark',data.remark);
                    // formData.append('image_file',data.image_file);
                    formData.append('update_user',this.user.id);
                    formData.append('cheque_amount',data.cheque_amount);
                    if (this.form.image_file)
                        for (let i = 0; i < this.form.image_file.length; i++) {
                            formData.append('image_file[]', this.form.image_file[i]);
                        }

                    if(this.id){
                        formData.append("_method",'put');
                    }
                    //save log
                    let info = {
                        user : this.user,
                        status : 'save form',
                        time : moment().format("DD-MM-YYYY HH:mm:ss")
                    }
                    this.$store.dispatch('SaveExportation/SaveLog',info);
                    this.$store.dispatch("SaveExportation/saveSaveExportation",{
                        id : this.id,
                        data : formData
                    }).then(()=>{
                        this.hideLoadingModal();
                        this.goToSaveExportationList();
                    });
                }else{
                    this.$refs.warning.hide();
                }
            },
            goToSaveExportationList(){
                this.$router.push({
                    name:"save-exportation"
                });
            },
            clearCheckbox(payment_checkbox){
                this.payment_type_status = 0;
                if(payment_checkbox && payment_checkbox.includes("1")){
                    this.form.payment_type_id = ["1"];
                    this.form.transaction_id = [];
                    this.payment_type_status = 1;
                    this.form.amount = "";
                    // this.form.transaction_id = 2;
                }
            },

            getSpecialCustomer(){
                if(this.form.invoice && this.form.invoice.customer){
                    if(this.form.invoice.customer.special_customer){
                        this.form.payment_type_id = ["1"];
                    }
                    else{
                        this.form.payment_type_id = [];
                    }
                }
            }

        },
    };
</script>

<style scoped>
table{
    border: 1px solid;
}
th{
    border-bottom: 1px solid;
    background-color: #F9C867;
}
</style>
